<main>
  <div class="position-relative">
    <!-- shape Hero -->
    <section class="section section-lg section-shaped pb-250 header-filter">
      <div class="container py-lg-md d-flex mt-5">
        <div class="col px-0">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-6 text-center">
              <!-- infinite loop -->
              <ngx-typed-js
                [strings]="[' Services']"
                [loop]="true"
                [stringsElement]="null"
                [typeSpeed]="100"
                [startDelay]="1200"
                [backSpeed]="100"
                [backDelay]="150"
                [loop]="true"
                [loopCount]="false"
                [showCursor]="false"
                [fadeOut]="true"
                (completed)="doSmth()"
              >
                <h1 class="display-1 text-white pre">
                  Our best <span class="typing"></span>
                </h1>
              </ngx-typed-js>
              <!-- <h1 class="display-3 text-white">
                Our Best Services
              </h1> -->
              <p class="lead text-white">
                A Complete Solution for your Digital Vision.
                <!-- Our any Creative Project Unique and should be provided with
                appropriate quality. We have one stop solution in Software
                Industries. -->
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- SVG separator -->
      <div class="separator separator-bottom separator-skew">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </section>
    <!-- 1st Hero Variation -->
  </div>
  <section class="section section-lg pt-lg-0 mt--200">
    <div class="home-services-card">
      <div class="container" data-aos="zoom-in">
        <div class="service-wrap">
          <div class="card-box" data-aos="fade-up" data-aos-delay="200">
            <div class="card-box-inner">
              <div class="front-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/soft_dev.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Software Development</h4>
                <p>
                  We offer modern designs coupled with a remarkable user
                  experience to build softwares and custom web applications that
                  are stunning, robust and scalable.
                </p>
              </div>
              <div class="back-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/soft_dev_white.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Software Development</h4>
                <ul>
                  <li>MEAN/MERN Stack Development</li>
                  <li>Web Application Development</li>
                  <li>BlockChain Development</li>
                  <li>AI &amp; ML - Python</li>
                  <li>IoT Applications</li>
                </ul>
                <a routerLink="/service/software-development" class="know-more"
                  >Know More....</a
                >
              </div>
            </div>
          </div>
          <div class="card-box" data-aos="fade-up" data-aos-delay="400">
            <div class="card-box-inner">
              <div class="front-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/ui_ux.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Website Design</h4>
                <p>
                  We provide a user experience that will translate into
                  increased usability and long term customer loyalty. We design
                  all types of website.
                </p>
              </div>
              <div class="back-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/ui_ux_white.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Website Design</h4>
                <ul>
                  <li>Personal, Portal, Portfolio</li>
                  <li>Media or Entertainment</li>
                  <li>Educational, Nonprofit</li>
                  <li>Blogs, Business</li>
                  <li>Ecommerce</li>
                </ul>
                <a routerLink="/service/website-designing" class="know-more"
                  >Know More....</a
                >
              </div>
            </div>
          </div>
          <div class="card-box" data-aos="fade-up" data-aos-delay="200">
            <div class="card-box-inner">
              <div class="front-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/mobile_app.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Mobile App</h4>
                <p>
                  We provide the best mobile app design and development
                  services, technologies &amp; frameworks, help us create secure
                  &amp; scalable Mobile Apps. offering support for both IOS and
                  Android operating systems.
                </p>
              </div>
              <div class="back-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/mobile_app_white.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Mobile App</h4>
                <ul>
                  <li>Android App Development</li>
                  <li>Ionic App Development</li>
                  <li>iOS App Development</li>
                  <li>React Native Apps</li>
                  <li>Web view Apps</li>
                  <li>Flutter</li>
                </ul>
                <a routerLink="/service/mobile-application" class="know-more"
                  >Know More....</a
                >
              </div>
            </div>
          </div>
          <div class="card-box" data-aos="fade-up" data-aos-delay="400">
            <div class="card-box-inner">
              <div class="front-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/website_design.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Web Development</h4>
                <p>
                  We use the latest stack technologies in order to put you one
                  step ahead of your competition - and helps us build world
                  class websites and web applications.
                </p>
              </div>
              <div class="back-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/website_design_white.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Web Development</h4>
                <ul>
                  <li>Ecommerce Development</li>
                  <li>Wordpress & PHP based</li>
                  <li>React JS Development</li>
                  <li>Node JS Development</li>
                  <li>Angular Development</li>
                  <li>CMS Development</li>
                </ul>
                <a routerLink="/service/website-development" class="know-more"
                  >Know More....</a
                >
              </div>
            </div>
          </div>
          <div class="card-box" data-aos="fade-up" data-aos-delay="600">
            <div class="card-box-inner">
              <div class="front-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/branding.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Branding</h4>
                <p>
                  Our highly creative team of designers always excels in
                  creating unique brand identity and out-of-the-box designs that
                  speaks on its own!
                </p>
              </div>
              <div class="back-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/branding_white.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Branding</h4>
                <ul>
                  <li>Social Media Post Design</li>
                  <li>Logo &amp; Brand Identity</li>
                  <li>Infographics Design</li>
                  <li>Graphic Design</li>
                  <li>Package Design</li>
                  <li>Print Design</li>
                </ul>
                <a routerLink="/service/branding" class="know-more"
                  >Know More....</a
                >
              </div>
            </div>
          </div>
          <div class="card-box" data-aos="fade-up" data-aos-delay="800">
            <div class="card-box-inner">
              <div class="front-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/video.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Video Productions</h4>
                <p>
                  We create awesome explainer videos of all types, that'd
                  improve your brand story telling &amp; user engagement which
                  results in higher conversions
                </p>
              </div>
              <div class="back-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/video_white.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Video Productions</h4>
                <ul>
                  <li>2D Animated Videos</li>
                  <li>3D Animated Videos</li>
                  <li>Explainer Videos</li>
                  <li>Motion Graphics</li>
                </ul>
                <a routerLink="/service/multimedia-solution" class="know-more"
                  >Know More....</a
                >
              </div>
            </div>
          </div>
          <div class="card-box" data-aos="fade-up" data-aos-delay="600">
            <div class="card-box-inner">
              <div class="front-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/digital.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Digital Marketing</h4>
                <p>
                  We help you create a significant online identity for your
                  website or mobile app, through our excellent branding and
                  digital marketing services.
                </p>
              </div>
              <div class="back-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/digital_white.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Digital Marketing</h4>
                <ul>
                  <li>Search Engine Optimization(SEO)</li>
                  <li>Search Engine Marketing(SEM)</li>
                  <li>Social Media Marketing</li>
                  <li>Analytics Consultation</li>
                  <li>Email Marketing</li>
                </ul>
                <a routerLink="/service/digital-marketing" class="know-more"
                  >Know More....</a
                >
              </div>
            </div>
          </div>
          <div class="card-box" data-aos="fade-up" data-aos-delay="800">
            <div class="card-box-inner">
              <div class="front-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/hosting.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Hosting</h4>
                <p>
                  Our experts have curated the best website hosting services. We
                  provide Secure & Easy Website Hosting Services.
                </p>
              </div>
              <div class="back-side card_height" style="height: 380px;">
                <!-- <span class="svg-icon"
                    ><img
                      src="../../../../../../../assets/img/icons/service-icon/hosting_white.svg"
                      alt="Eduvita Software Development Company"
                  /></span> -->

                <h4>Hosting</h4>
                <ul>
                  <li>Professional email hosting</li>
                  <li>Dedicated hosting</li>
                  <li>hosting transfer</li>
                  <li>Shared hosting</li>
                  <li>Cloud hosting</li>
                  <li>VPS hosting</li>
                </ul>
                <a routerLink="/service/web-hosting-services" class="know-more"
                  >Know More....</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Call to action -->
  <section class="section pt-0" data-aos="zoom-in" data-aos-delay="800">
    <div class="container">
      <div class="card bg-gradient-warning shadow-lg border-0">
        <div class="p-5">
          <div class="row align-items-center">
            <div class="col-lg-8">
              <h3 class="text-white">
                Drive your online business to success.
              </h3>
              <p class="lead text-white mt-3">
                Contact us now to know all about our brilliant offerings
              </p>
            </div>
            <div class="col-lg-3 ml-lg-auto">
              <a
                href="javascript:void(0)"
                class="btn btn-lg btn-block btn-white"
                >Get In Touch</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
